import { api } from '@/helpers/core'

export default {
	version () {
		return api.get('/settings/version/')
	}
}
